module.exports = __webpack_public_path__ + "img/107031.25825ef6.png";